import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConstants} from '@coreConstant';
import {PaginationModel, RequestParamModel, QuoteOrdersModel} from '@coreModels';
import {catchError, map, Observable, throwError} from 'rxjs';
import {BaseService} from './base.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteOrdersService {

  constructor(private http: HttpClient, private baseService: BaseService) {
  }

  createQuoteOrder(data: any): any {
    return this.http.post(ApiConstants.QUOTE_ORDER_CREATE_URL, data);
  }

  saveQuoteProduct(quoteProductModel: any) {
    if (quoteProductModel.id) {
      let id = quoteProductModel.id;
      delete quoteProductModel.id;
      return this.http.patch(ApiConstants.QUOTE_ORDER_PRODUCT_UPDATE_URL + id, quoteProductModel)
        .pipe(map<any, number>(response => {
          quoteProductModel = response.data as any;
          return quoteProductModel.id;
        }), catchError((err: any) => {
          return throwError(() => err);
        }));
    } else {
      return this.http.post(ApiConstants.QUOTE_ORDER_PRODUCT_CREATE_URL, quoteProductModel)
        .pipe(map<any, number>(response => {
          quoteProductModel = response.data as any;
          return quoteProductModel.id;
        }), catchError((err: any) => {
          return throwError(() => err);
        }));
    }
    // return this.http.post(ApiConstants.QUOTE_ORDER_PRODUCT_CREATE_URL, quoteProductModel)
    //   .pipe(map<any, number>(response => {
    //     quoteProductModel = response.data as any;
    //     return quoteProductModel.id;
    //   }), catchError((err: any) => {
    //     return throwError(() => err);
    //   }));
  }

  saveQuoteProductAppliedCalculator(quoteProductAppliedCalculatorModel: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_PRODUCT_APPLIED_CALCULATOR_CREATE_URL, quoteProductAppliedCalculatorModel)
      .pipe(map<any, number>(response => {
        quoteProductAppliedCalculatorModel = response.data as any;
        return quoteProductAppliedCalculatorModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  saveQuoteProductAppliedCalculatorByExportId(quoteProductAppliedCalculatorModel: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_PRODUCT_APPLIED_CALCULATOR_CREATE_BY_EXPORT_ID_URL, quoteProductAppliedCalculatorModel)
      .pipe(map<any, number>(response => {
        quoteProductAppliedCalculatorModel = response.data as any;
        return quoteProductAppliedCalculatorModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  reCalculateQuotePrice(quoteModel: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_RE_CALCULATE_PRICE_URL, quoteModel)
      .pipe(map<any, number>(response => {
        quoteModel = response.data as any;
        return quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  reCalculateQuotePriceByExportId(quoteModel: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_RE_CALCULATE_PRICE_BY_EXPORT_ID_URL, quoteModel)
      .pipe(map<any, number>(response => {
        quoteModel = response.data as any;
        return quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getQuoteOrders(requestParamModel: RequestParamModel): any {
    return this.http.get(ApiConstants.QUOTE_ORDER_LIST_URL + requestParamModel.getParams(), {observe: 'response'})
      .pipe(map<any, any>(response => {
        const accountList = new PaginationModel<QuoteOrdersModel>();
        const headers = response.headers;
        accountList.setHeaders(headers);
        accountList.data = response.body.data as QuoteOrdersModel[];
        return accountList;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getQuoteData(quoteID: number, requestParamModel?: RequestParamModel) {
    return this.http.get(ApiConstants.QUOTE_ORDER_DETAIL_URL + quoteID + requestParamModel?.getParams())
      .pipe(map<any, QuoteOrdersModel>(response => {
        return response.data as QuoteOrdersModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  deleteQuoteProducts(id: any) {
    return this.http.delete(ApiConstants.QUOTE_ORDER_PRODUCT_DELETE_URL + id);
  }

  deleteQuoteProductAppliedCalculator(id: any) {
    return this.http.delete(ApiConstants.QUOTE_ORDER_PRODUCT_APPLIED_CALCULATOR_DELETE_URL + id)
      .pipe(map<any, number>(response => {
        return response;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  deleteQuoteProductAppliedCalculatorByExportId(exportId: any, id: any) {
    return this.http.delete(ApiConstants.QUOTE_ORDER_PRODUCT_APPLIED_CALCULATOR_DELETE_BY_EXPORT_ID_URL + '/' + exportId + '/' + id)
      .pipe(map<any, number>(response => {
        return response;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getConsumableDetail(requestParamModel: RequestParamModel): any {
    return this.http.get(ApiConstants.QUOTE_ORDER_PRODUCT_APPLIED_CALCULATOR_LIST_URL + requestParamModel.getParams(), {observe: 'response'})
      .pipe(map<any, any>(response => {
        const regionList = new PaginationModel<QuoteOrdersModel>();
        const headers = response.headers;
        regionList.setHeaders(headers);
        regionList.data = response.body.data as any;
        return regionList;
        // return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  reactiveQuote(data: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_REACTIVATE_URL, data)
      .pipe(map<any, any>(response => {
        return response.data as any;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  deleteQuoteOrders(_id: any) {
    return this.http.delete(ApiConstants.QUOTE_ORDER_DELETE_URL + _id)
      .pipe(map<any, any>(response => {
        return '';
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getCounter(requestParamModel: RequestParamModel) {
    return this.http.get(ApiConstants.QUOTE_ORDER_COUNTER_URL + requestParamModel?.getParams())
      .pipe(map<any, QuoteOrdersModel>(response => {
        return response.data as QuoteOrdersModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  quoteExportPDF(endpoint: any, formData: any) {
    return this.http.post(endpoint, formData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getTotalSampleProductCounter(requestParamModel: RequestParamModel) {
    return this.http.get(ApiConstants.QUOTE_ORDER_SAMPLE_PRODUCT_COUNTER_URL + requestParamModel?.getParams())
      .pipe(map<any, QuoteOrdersModel>(response => {
          return response.data as QuoteOrdersModel;
        }),
        catchError((err: any) => {
          return throwError(() => err);
        }));
  }

  getSampleDetails(quoteID: number, requestParamModel: RequestParamModel): any {
    return this.http.get(ApiConstants.QUOTE_ORDER_DETAIL_URL + quoteID + requestParamModel.getParams(), {observe: 'response'})
      .pipe(map<any, any>(response => {
        const sampleList = new PaginationModel<QuoteOrdersModel>();
        const headers = response.headers;
        sampleList.setHeaders(headers);
        sampleList.data = response.body.data as QuoteOrdersModel[];
        return sampleList;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  generateExportId(id: any, requestParamModel: RequestParamModel) {
    return this.baseService.get(ApiConstants.QUOTE_ORDER_GENERATE_EXPORT_ID_URL + id, requestParamModel)
      .pipe(map((response: any) => {
          return response.body.data as any;
        }),
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  }

  getOrderCounts(requestParamModel: RequestParamModel) {
    return this.http.get(ApiConstants.QUOTE_ORDERS_COUNTS_URL + requestParamModel.getParams())
      .pipe(map((response: any) => {
        return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getTruckDetail(requestParamModel: RequestParamModel) {
    return this.baseService.get(ApiConstants.QUOTE_ORDER_TRUCK_TYPE_LIST_URL, requestParamModel)
      .pipe(map((response: any) => {
          return response.body.data as any;
        }),
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  }

  addReviewToQuote(quoteReviewModel: any) {
    return this.baseService.post(ApiConstants.QUOTE_ORDER_FEEDBACK_URL, quoteReviewModel).pipe(map<any, any>(response => {
        return response.data as any;
      }),
      catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getShippingCost(requestData: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_SHIPPING_CALCULATION_URL, requestData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  saveQuoteOrder(requestData: any, returnResponse: boolean = false) {
    if (requestData.id) {
      return this.http.patch(ApiConstants.QUOTE_ORDER_UPDATE_URL + requestData.id, requestData)
        .pipe(map<any, number>(response => {
          let quoteModel = response.data as any;
          return returnResponse ? quoteModel : quoteModel.id;
        }), catchError((err: any) => {
          return throwError(() => err);
        }));
    } else {
      return this.http.post(ApiConstants.QUOTE_ORDER_CREATE_URL + '/create', requestData)
        .pipe(map<any, number>(response => {
          let quoteModel = response.data as any;
          return returnResponse ? quoteModel : quoteModel.id;
        }), catchError((err: any) => {
          return throwError(() => err);
        }));
    }
  }

  saveQuoteOrderByExportId(requestData: any, returnResponse: boolean = false) {
    return this.http.post(ApiConstants.QUOTE_ORDER_UPDATE_BY_EXPORT_ID_URL, requestData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return returnResponse ? quoteModel : quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  changeStatusByExportId(requestData: any): Observable<number> {
    return this.http.post(ApiConstants.QUOTE_ORDER_STATUS_UPDATE_BY_EXPORT_ID_URL, requestData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  changeStatus(requestData: any) {
    return this.http.patch(ApiConstants.QUOTE_ORDER_STATUS_UPDATE_URL + requestData.id, requestData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateSiteContactDetail(endpoint: string, accountModel: any): Observable<any> {
    return this.http.post(endpoint, accountModel)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  deleteAllQuoteProductAppliedCalculators(_id: any) {
    return this.http.delete(ApiConstants.QUOTE_ORDER_DELETE_ALL_PRODUCT_APPLIED_CALCULATOR_URL + _id);
  }

  getQuotePayment(formData: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_PAYMENT_LIST_URL, formData)
      .pipe(map<any, number>(response => {
        return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  uploadPaymentReceiptByExportId(requestModel: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_UPLOAD_PAYMENT_RECEIPT_URL, requestModel).pipe(
      map<any, any>(response => {
        return response.body;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  checkExportData(requestBody: any): any {
    return this.http.post(ApiConstants.QUOTE_ORDER_CHECK_EXPORT_ID_URL, requestBody)
      .pipe(map<any, any>(response => {
        return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  downloadQuoteOrder(param: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_DOWNLOAD_URL, param)
      .pipe(map<any, any>(response => {
        return response.data as any;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  downloadQuoteOrderByExportId(param: any) {
    return this.http.post(ApiConstants.QUOTE_ORDER_DOWNLOAD_BY_EXPORT_ID_URL, param)
      .pipe(map<any, any>(response => {
        return response.data as any;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  downloadQuoteOrderNew(body: any) {
    return this.baseService.getDownloadFileContent(ApiConstants.QUOTE_ORDER_DOWNLOAD_FILE_URL + `${body.file_name}`);
  }

  downloadQuoteOrderFileByExportId(body: any, exportId: string) {
    return this.baseService.getDownloadFileContent(ApiConstants.QUOTE_ORDER_DOWNLOAD_FILE_BY_EXPORT_ID_URL + `${body.file_name}` + '&id=' + `${exportId}`);
  }

  getQuoteDetailByExportId(requestParamModel: RequestParamModel): Observable<QuoteOrdersModel> {
    return this.http.get(`${ApiConstants.QUOTE_ORDER_DETAIL_BY_ID_URL}${requestParamModel.getParams()}`)
      .pipe(map<any, any>(response => {
        return response.data as QuoteOrdersModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getOrderDetailByTrackingId(requestParamModel: RequestParamModel): Observable<QuoteOrdersModel> {
    return this.http.get(`${ApiConstants.TRACK_ORDER_DETAIL_BY_ID_URL}${requestParamModel.getParams()}`)
      .pipe(map<any, any>(response => {
        return response.data as QuoteOrdersModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getPaymentLinkByExportId(formData: any): Observable<any> {
    return this.http.post(ApiConstants.QUOTE_ORDER_PAYMENT_LINK_BY_EXPORT_ID_URL, formData)
      .pipe(map<any, any>(response => {
        return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  quoteValidateToken(formData: any): Observable<any> {
    return this.http.post(ApiConstants.QUOTE_ORDER_PAYMENT_VALIDATE_TOKEN_URL, formData)
      .pipe(map<any, any>(response => {
        return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  confirmJob(requestBody: any): any {
    return this.http.post(ApiConstants.QUOTE_ORDER_CONFIRM_JOB_URL, requestBody)
      .pipe(map<any, any>(response => {
        return response.data;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateDeliveryAddress(requestData: any, returnResponse: boolean = false) {
    return this.http.patch(ApiConstants.QUOTE_ORDER_DELIVERY_DETAIL_UPDATE_URL + requestData.id, requestData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return returnResponse ? quoteModel : quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateDeliveryAddressByIdentifier(endpoint: string, accountModel: any): Observable<any> {
    return this.http.post(endpoint, accountModel)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateStockRequiredDate(requestData: any, returnResponse: boolean = false) {
    return this.http.patch(ApiConstants.QUOTE_ORDER_STOCK_REQUIRED_DATE_UPDATE_URL + requestData.id, requestData)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return returnResponse ? quoteModel : quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateStockRequiredDateByIdentifier(endpoint: string, accountModel: any): Observable<any> {
    return this.http.post(endpoint, accountModel)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateStatusOnAddressOrProductChange(requestData: any, returnResponse: boolean = false) {
    let id = requestData.id;
    delete requestData.id;
    return this.http.patch(ApiConstants.QUOTE_UPDATE_STATUS_ON_ADDRESS_OR_PRODUCT_CHANGE_URL + id, null)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return returnResponse ? quoteModel : quoteModel.id;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateStatusOnAddressOrProductChangeByIdentifier(endpoint: string, accountModel: any): Observable<any> {
    return this.http.post(endpoint, accountModel)
      .pipe(map<any, number>(response => {
        let quoteModel = response.data as any;
        return quoteModel;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  updateQuoteOrder(orderModel: any): Observable<QuoteOrdersModel> {
    return this.http.patch(ApiConstants.QUOTE_ORDER_UPDATE_URL + orderModel.id, orderModel)
      .pipe(
        map((response: any) => {
          return response.data as QuoteOrdersModel;
        }),
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  }
}


